'use client';
import { Slider, SliderProps, SxProps, Theme } from '@mui/material';
import React, { FC } from 'react';
import classes from './styles.module.scss';
import { removeCommas } from '@/utils';

import SliderLabel from './label';

const styles: Record<string, SxProps<Theme>> = {
    slider: {
        height: '8px',
        '& .MuiSlider-thumb': {
            bgcolor: '#fff',
            borderWidth: '20px',
            border: 1.5,
        },
        '& .MuiSlider-rail': {
            bgcolor: '#EAECF0',
            opacity: 1,
        },
        '& .MuiSlider-mark': {
            height: '6px',
            bgcolor: '#D0D5DD',
        },
        '& .MuiSlider-markActive': {
            height: '0px',
        },
        '& .MuiSlider-valueLabel': {
            bgcolor: '#FFFFFF',
            boxShadow: 6,
            padding: '8px 12px',
            borderRadius: '8px',
            ':before': {
                display: 'none',
            },
        },
        '& .MuiSlider-valueLabelLabel': {
            color: '#000',
        },
    },
    sliderBottom: {
        height: '8px',
        '& .MuiSlider-thumb': {
            bgcolor: '#fff',
            borderWidth: '20px',
            border: 1.5,
        },
        '& .MuiSlider-rail': {
            bgcolor: '#EAECF0',
            opacity: 1,
        },
        '& .MuiSlider-mark': {
            height: '6px',
            bgcolor: '#D0D5DD',
        },
        '& .MuiSlider-markActive': {
            height: '0px',
        },
        '& .MuiSlider-valueLabel': {
            bgcolor: '#FFFFFF',
            boxShadow: 6,
            padding: '8px 12px',
            borderRadius: '8px',
            ':before': {
                display: 'none',
            },
            top: '60px',
        },
        '& .MuiSlider-valueLabelLabel': {
            color: '#000',
        },
    },
};

interface ISlider {
    sliderLabel?: boolean;
    labelAbove?: boolean;
}
const WrappedSlider: FC<SliderProps & ISlider> = ({
    sliderLabel = false,
    labelAbove = false,
    ...props
}) => {
    return (
        <div className={classes.input_container} id={'finance-slider'}>
            <Slider
                {...props}
                value={removeCommas((props.value || 0) as number)}
                onChange={props.onChange}
                min={props.min || 0}
                max={props.max || 1000}
                sx={labelAbove ? styles.slider : styles.sliderBottom}
            />
            {sliderLabel && (
                <SliderLabel min={props.min || 0} max={props.max || 0} />
            )}
        </div>
    );
};

export default WrappedSlider;
